import React, { useState } from "react";
import { Dropdown, Menu, Modal, Tooltip } from "antd";
import { Link } from "react-router-dom";
import LoadingSkeleton from "../loading-sekeleton/LoadingSkeleton";
import {
	ActionButton,
	AntdTable,
	ColorState,
	Container,
	Section,
	StateContainer,
} from "./styles";
import { BsInfoCircle, BsThreeDotsVertical } from "react-icons/bs";
import { MdComputer } from "react-icons/md";
import { BiMobile } from "react-icons/bi";
import moment from "moment";
import { FiPhoneCall } from "react-icons/fi";
import { COLORS, Typo } from "../../../../../layout/theme";
import { numberWithDotAndCommas } from "../../../../../../utils/numberWithDotAndComas";
import SaleDetailModal from "../sale-detail-modal/SaleDetailModal";
import { GiArtificialIntelligence } from "react-icons/gi";
import { FaHeadset } from "react-icons/fa";
import { AiOutlineAudit } from "react-icons/ai";

export default function SalesReportTable({ data, details, ...props }) {
	const [key, setKey] = useState(null);
	const [isModalVisible, setIsModalVisible] = useState(false);
	const [modalInfo, setModalInfo] = useState(null);

	const columns = [
		{
			title: () => {
				return (
					<div
						style={{
							color: COLORS.White,
						}}
					>
						N° TRF
					</div>
				);
			},
			dataIndex: "orderNumId",
			render: (f, r) => (
				<Section>
					<Container
						cursor="pointer"
						onMouseOver={() => setKey(r?.id)}
						onClick={() => handleDetail(r)}
					>
						<Typo type="primary" fontWeight={600} fontSize={14}>
							{f}
						</Typo>
						{r.orderHasMegaDistributor > 0 && (
							<Tooltip
								title={`Productos a Distribuidor: ${r.orderHasMegaDistributor}`}
							>
								<BsInfoCircle color={COLORS.Secondary} />
							</Tooltip>
						)}
					</Container>
					<Typo type="mediumGrey" fontWeight={500} fontSize={13}>
						{moment(r.created).format("DD/MM/YYYY")}
					</Typo>
				</Section>
			),
		},
		{
			title: () => {
				return (
					<div
						style={{
							color: COLORS.White,
							fontWeight: 700,
							textAlign: "center",
						}}
					>
						ORIGEN
					</div>
				);
			},
			dataIndex: "typeOfSale",
			render: (f, r) => (
				<div
					style={{
						textAlign: "center",
					}}
				>
					<Typo
						type="darkGrey"
						fontWeight={600}
						fontSize={14}
						// onClick={() => showModal(r)}
						// style={{ cursor: "pointer" }}
					>
						{r.typeOfSale === "IASELL" ? (
							<GiArtificialIntelligence />
						) : r.typeOfSale === "WEB" && r.sellerClientName !== "OneMarket" ? (
							<MdComputer />
						) : r.typeOfSale === "WEBSELLER" ? (
							<FaHeadset />
						) : f === "EXPO" ? (
							<AiOutlineAudit />
						) : r.typeOfSale === "MOBILE" ? (
							<>
								<BiMobile />{" "}
								<Typo type="darkGrey" fontWeight={600} fontSize={12}>
									App
								</Typo>
							</>
						) : (
							<FiPhoneCall />
						)}
					</Typo>
				</div>
			),
		},
		{
			title: () => {
				return (
					<div
						style={{
							color: COLORS.White,
							fontWeight: 700,
						}}
					>
						DROGUERIA
					</div>
				);
			},
			dataIndex: "distributorName",
			render: (f) => (
				<Typo type="darkGrey" fontWeight={600} fontSize={14}>
					{f}
				</Typo>
			),
		},
		{
			title: () => {
				return (
					<div
						style={{
							color: COLORS.White,
							fontWeight: 700,
						}}
					>
						PUNTO DE VENTA
					</div>
				);
			},
			dataIndex: "pointOfSaleName",
			render: (f) => (
				<Typo type="darkGrey" fontWeight={600} fontSize={14}>
					{f}
				</Typo>
			),
		},
		{
			title: () => {
				return (
					<div
						style={{
							color: COLORS.White,
							fontWeight: 700,
							textAlign: "center",
						}}
					>
						ITEMS
					</div>
				);
			},
			dataIndex: "qtyItems",
			render: (f) => (
				<div
					style={{
						textAlign: "center",
					}}
				>
					<Typo type="darkGrey" fontWeight={600} fontSize={14}>
						{f}
					</Typo>
				</div>
			),
		},
		{
			title: () => {
				return (
					<div
						style={{
							color: COLORS.White,
							fontWeight: 700,
							textAlign: "end",
						}}
					>
						TOTAL
					</div>
				);
			},
			width: 250,
			dataIndex: "total",
			render: (f, record) => (
				<Section style={{ alignItems: "end" }}>
					<Typo type="primary" fontWeight={700} fontSize={15}>
						$ {numberWithDotAndCommas(parseFloat(f))}
					</Typo>
					<Typo type="success" fontWeight={500} fontSize={13}>
						{record.discount === 0
							? ``
							: `Desc.: $ ${numberWithDotAndCommas(parseFloat(record.discount))} `}
					</Typo>
				</Section>
			),
		},
		{
			title: () => {
				return (
					<div
						style={{
							color: COLORS.White,
							fontWeight: 700,
							textAlign: "center",
						}}
					>
						ESTADO
					</div>
				);
			},
			width: 180,
			dataIndex: "orderState",
			render: (fila, record) => {
				let colorBackground = COLORS.LightGrey3;
				let colorText = COLORS.MediumGrey;

				switch (fila) {
					case "PROCESADA":
						colorBackground = COLORS.LightDefault;
						colorText = COLORS.Default;
						break;
					case "Pending":
						colorBackground = COLORS.LightWarning;
						colorText = COLORS.Warning;
						break;
					case "Active":
						colorBackground = COLORS.LightSecondary;
						colorText = COLORS.Secondary;
						break;
					case "Sended":
						colorBackground = COLORS.LightSuccess;
						colorText = COLORS.Success;
						break;
					case "Canceled":
						colorBackground = COLORS.LightDanger;
						colorText = COLORS.Danger;
						break;

					default:
						break;
				}

				return (
					<StateContainer>
						<ColorState colorBackground={colorBackground}>
							{record.orderSubState ? (
								<Typo fontWeight={600} fontSize={14}>
									{record.orderSubState === "PROCESADA" && "Procesada"}
								</Typo>
							) : (
								<Typo
									fontWeight={600}
									fontSize={14}
									style={{ color: colorText }}
								>
									{fila === "Pending" && "Pendiente"}
									{fila === "Active" && "Activa"}
									{fila === "Sended" && "Enviada"}
									{fila === "Canceled" && "Cancelada"}
								</Typo>
							)}
						</ColorState>
					</StateContainer>
				);
			},
		},
	];

	const handleDetail = async (r) => {
		setModalInfo(details?.filter((o) => o.orderNumId === r.orderNumId));
		setIsModalVisible(true);
	};

	const handleOk = () => {
		setIsModalVisible(false);
	};

	const handleCancel = () => {
		setIsModalVisible(false);
	};

	if (!data) return <LoadingSkeleton />;

	return (
		<>
			<AntdTable columns={columns} dataSource={data} {...props} />
			<Modal
				title={
					<div style={{ height: 30 }}>
						<Typo level={6} type="muted">
							Detalle orden: {key?.orderNumId}
						</Typo>
					</div>
				}
				visible={isModalVisible}
				onOk={handleOk}
				onCancel={handleCancel}
				width={1200}
				centered={true}
				footer={null}
				destroyOnClose
			>
				<SaleDetailModal modalInfo={modalInfo} />
			</Modal>
		</>
	);
}
